module.exports = __webpack_public_path__ + "img/carpeting.7e9b1f72.jpg";